export enum PrintCardProperty {
  Name = 'Name',
  Brand = 'Brand',
  Manufacturer = 'Manufacturer',
  SKU = 'SKU',
  Barcode = 'Barcode',
  Description = 'Description',
  StrainType = 'StrainType',
  UnitSize = 'UnitSize',
  PackageQuantity = 'PackagedQuantity',
  ProductTypeVariantType = 'ProductTypeVariantType',
  Strain = 'Strain',
  Lineage = 'Lineage',
  IsMedical = 'IsMedical',
  Price = 'Price',
  SecondaryPrice = 'SecondaryPrice',
  Label = 'Label',
  Badges = 'Badges',
  CompanyLogo = 'CompanyLogo',
  THC = 'THC',
  CBD = 'CBD',
  TAC = 'TAC',
  EnabledSecondaryCannabinoids = 'EnabledSecondaryCannabinoids',
  TopTerpene = 'TopTerpene',
  TotalTerpene = 'TotalTerpene',
  PresentTerpenes = 'PresentTerpenes',
  EnabledTerpenes = 'EnabledTerpenes'
}

export class PrintCardPropertyDefinition {
  public static productPropertyList = [
    PrintCardProperty.Name,
    PrintCardProperty.Brand,
    PrintCardProperty.Manufacturer,
    PrintCardProperty.SKU,
    PrintCardProperty.Barcode,
    PrintCardProperty.Description,
    PrintCardProperty.StrainType,
    PrintCardProperty.UnitSize,
    PrintCardProperty.PackageQuantity,
    PrintCardProperty.ProductTypeVariantType,
    PrintCardProperty.Strain,
    PrintCardProperty.IsMedical,
    PrintCardProperty.Price,
    PrintCardProperty.SecondaryPrice,
    PrintCardProperty.Label,
    PrintCardProperty.Badges,
    PrintCardProperty.CompanyLogo,
    PrintCardProperty.Lineage
  ];

  public static primaryPropertyList = [
    PrintCardProperty.TotalTerpene,
    PrintCardProperty.TAC,
    PrintCardProperty.TopTerpene,
    PrintCardProperty.PresentTerpenes
  ];

  public static secondaryPropertyList = [
    PrintCardProperty.THC,
    PrintCardProperty.CBD,
    PrintCardProperty.EnabledSecondaryCannabinoids,
    PrintCardProperty.EnabledTerpenes
  ];

  public static cannabinoidPropertyList = [
    PrintCardProperty.THC,
    PrintCardProperty.CBD,
    PrintCardProperty.TAC,
    PrintCardProperty.EnabledSecondaryCannabinoids
  ];

  public static terpenePropertyList = [
    PrintCardProperty.TopTerpene,
    PrintCardProperty.TotalTerpene,
    PrintCardProperty.PresentTerpenes,
    PrintCardProperty.EnabledTerpenes
  ];

  value: PrintCardProperty;

  public isProductProperty(): boolean {
    return PrintCardPropertyDefinition.productPropertyList.includes(this.value);
  }

  public isCannabinoidProperty(): boolean {
    return PrintCardPropertyDefinition.cannabinoidPropertyList.includes(this.value);
  }

  public isPrimaryCannabinoidProperty(): boolean {
    return this.value === PrintCardProperty.CBD || this.value === PrintCardProperty.THC;
  }

  public isTerpeneProperty(): boolean {
    return PrintCardPropertyDefinition.terpenePropertyList.includes(this.value);
  }

  public isCollectiveTerpeneProperty(): boolean {
    return this.value === PrintCardProperty.TopTerpene || this.value === PrintCardProperty.TotalTerpene;
  }
}
